import React, {useState, useEffect} from 'react';
import useUserContext from '../common/UserContext';
import { apiGet, getAccountsApiUrl } from '../common/AppApi';
import { saveUser } from '../common/AppAuth';
import Processing from '../common/Processing';

export default function Home() {
	let {user, setUser} = useUserContext();
	let [program, setProgram] = useState(null);
	let [showSpinner, setSpinner] = useState(false);

	let getPrograms = () => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/account/programs';
		apiGet(url).then((resp)=> {
			if (resp && resp.length && resp.length > 0)
				setProgram(resp[0]);
		}).catch( (err) => {
			console.error(err);
		}).finally( () => setSpinner(false));
	};

	let getOnlineApplications = () => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/application';
		apiGet(url).then((resp)=> {
			//console.log(resp);
			let currentUser = {...user};
			if (resp && resp.length) {
				currentUser.applications = resp;
				setUser(currentUser); // save to context
				saveUser(currentUser); // save to local storage
			}
		}).catch( (err) => {
			console.error(err);
		}).finally( () => setSpinner(false));
	};
	
	useEffect(() => {
		getPrograms();
		getOnlineApplications();
	}, []);

	return (
		<>
			<Processing show={showSpinner} />
			<p>
			Welcome to the TIMS Administrative Portal for {program ? program.programName : 'your program'}.
			</p>
			<p>
			This portal enables the management of electronic benefits issued by the program's Administrative Agency and provides access to and reporting on current program data.
			</p>

			<br/>
			<br/>
			<br/>

			<p>
			Any questions about the portal should be directed to Farmers Food Assistance Bureau (FFAB) at <a href="mailto:info@ffabureau.org">info@ffabureau.org</a>.
			</p>
		</>
	)
}
